import {useEffect, useRef, useState} from 'react'
import SectionTitle from '../../common/SectionTitle'
import Slick from 'react-slick'

import {Splide, SplideSlide} from '@splidejs/react-splide'
import '@splidejs/react-splide/css/core'

import './_DoctorsSection.scss'

import doc1 from '../../../assets/images/doctors-section/1.png'
import doc2 from '../../../assets/images/doctors-section/2.png'
import doc3 from '../../../assets/images/doctors-section/3.png'
import doc4 from '../../../assets/images/doctors-section/4.png'
import doc5 from '../../../assets/images/doctors-section/5.png'
import doc6 from '../../../assets/images/doctors-section/6.png'
import doc7 from '../../../assets/images/doctors-section/7.png'
import doc8 from '../../../assets/images/doctors-section/8.png'
import {log} from "@craco/craco/dist/lib/logger";

const newDoctors =
    [
        {
            "icon": doc1,
            "name": 'N/A',
            "title": 'Our doctors',
            "description": 'Allergist/Immunologist',
            "line": ['Identifying triggers and immune disorders.', 'Personalized care plans for allergies and immunity.', 'Building tolerance through gradual allergen exposure.']
        },
        {
            "icon": doc2,
            "name": 'N/A',
            "title": 'Our doctors',
            "description": 'Cardiologist',
            "line": [
                'Heart condition diagnosis and evaluation.',
                'Treatment and management of cardiovascular diseases.',
                'Perform cardiac procedures and surgeries.'
            ]
        },
        {
            "icon": doc3,
            "name": 'N/A',
            "title": 'Our doctors',
            "description": 'Dermatologist',
            "line": [
                'Skin condition diagnosis and evaluation.',
                'Treatment and management of dermatological disorders.',
                'Perform skin-related procedures and surgeries.'
            ]
        },
        {
            "icon": doc4,
            "name": "Gastroenterologists",
            "title": "Our doctors",
            "description": "Gastroenterologists",
            "line": [
                "Digestive system disorder diagnosis and evaluation.",
                "Treatment and management of gastrointestinal conditions.",
                "Perform endoscopic procedures and surgeries."
            ]
        },
        {
            "icon": doc5,
            "name": "Hematologists",
            "title": "Our doctors",
            "description": "Hematologists",
            "line": [
                "Diagnosis and treatment of blood disorders.",
                "Management of hematologic conditions.",
                "Perform blood-related procedures and transfusions."
            ]
        },
        {
            "icon": doc6,
            "name": "Ophthalmologists",
            "title": "Our doctors",
            "description": "Ophthalmologists",
            "line": [
                "Diagnosis and treatment of eye disorders.",
                "Perform eye examinations and prescribe corrective lenses.",
                "Conduct eye surgeries and laser procedures."
            ]
        },
        {
            "icon": doc7,
            "name": "Neurologists",
            "title": "Our doctors",
            "description": "Neurologists",
            "line": [
                "Diagnosis and evaluation of neurological disorders.",
                "Treatment and management of brain and nervous system conditions.",
                "Perform neurological examinations and interpret diagnostic tests."
            ]
        },
        {
            "icon": doc8,
            "name": "Oncologists",
            "title": "Our doctors",
            "description": "Oncologists",
            "line": [
                "Diagnosis and staging of cancer.",
                "Development and implementation of cancer treatment plans.",
                "Administer chemotherapy and oversee cancer therapies."
            ]
        }
    ]
const DoctorsSection = () => {
    const slider = useRef(null)
    const gallerySlider = useRef(null)
    const [slideNumber, setSlideNumber] = useState(0)
    const settings = {
        arrows: false,
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: false,
        beforeChange: (current, next) => setSlideNumber(next),
        responsive: [{
            breakpoint: 833,
            settings: {
                draggable: true,
            },
        }],
    }

    const splideOptions = {
        rewind: true,
        fixedWidth: 160,
        isNavigation: true,
        gap: 24,
        focus: 'center',
        pagination: false,
        cover: true,
        type: 'loop',
        arrows: false,
        drag: false,
    }

    /**
     * @function changeSlide
     * @param {-1 | 1 | false} direction
     * @param {int} slide
     */

    const changeSlide = (direction, slide) => {
        if (slide !== undefined) {
            setSlideNumber(slide)
        }
        if (!direction) {
            slider?.current?.slickGoTo(slide)
            gallerySlider?.current?.go(slide)
            return
        }

        if (direction > 0) {
            slider?.current?.slickNext()
            gallerySlider?.current?.go('>')
        } else {
            slider?.current?.slickPrev()
            gallerySlider?.current?.go('<')
        }
    }
    const textBox = <div className='text-box'>
        <SectionTitle
            title={newDoctors[slideNumber]?.title}
            text={newDoctors[slideNumber]?.description}
        />
        <ul className='list'>
            {newDoctors[slideNumber]?.line?.map((text, i) => {
                return <li key={i}>{text}</li>
            })}
        </ul>
    </div>
    return (
        <div className='DoctorsSection' id='doctors'>
            <div className='section-padding'>
                <div className='container'>
                    <div className='doctor-box'>
                        <div className='slider-box'>
                            <Slick {...settings} ref={slider}>
                                {newDoctors.map((doctor, i) => <div className='img-box' key={i}>
                                    <img src={doctor.icon} alt=''/>
                                </div>)}
                            </Slick>
                            <div className='slick-slider-arrows center-x'>
                                <div className='arrow arrow-left' onClick={() => changeSlide(-1)}>
                                    <svg width="25" height="12" viewBox="0 0 25 12" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 5.59375L1.42836 5.59375" stroke="#386DF6" strokeWidth="2"
                                              strokeLinecap="round"/>
                                        <path
                                            d="M1.80705 5.92835L1.50452 5.59328L1.80705 5.25821L5.31016 1.37821C5.48496 1.18461 5.48763 0.832936 5.308 0.625975C5.1545 0.458262 4.93221 0.459055 4.77936 0.628352L0.635206 5.21835C0.454931 5.41802 0.454931 5.75854 0.635206 5.95821L4.77936 10.5482C4.93293 10.7183 5.15659 10.7183 5.31016 10.5482C5.49044 10.3485 5.49044 10.008 5.31016 9.80835L1.80705 5.92835Z"
                                            fill="white" stroke="#386DF6"/>
                                    </svg>
                                </div>
                                <div className='arrow arrow-right' onClick={() => changeSlide(1)}>
                                    <svg width="25" height="12" viewBox="0 0 25 12" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 5.58203L23.5716 5.58203" stroke="#386DF6" strokeWidth="2"
                                              strokeLinecap="round"/>
                                        <path
                                            d="M23.193 5.24743L23.4955 5.5825L23.193 5.91757L19.6898 9.79757C19.515 9.99117 19.5124 10.3428 19.692 10.5498C19.8455 10.7175 20.0678 10.7167 20.2206 10.5474L24.3648 5.95743C24.5451 5.75776 24.5451 5.41724 24.3648 5.21757L20.2206 0.627569C20.0671 0.457477 19.8434 0.457477 19.6898 0.627569C19.5096 0.827239 19.5096 1.16776 19.6898 1.36743L23.193 5.24743Z"
                                            fill="white" stroke="#386DF6"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        {textBox}
                    </div>
                </div>
            </div>
            <div className='doctors-gallery-slider-box'>
                <Splide onMoved={(e) => changeSlide(false, e.index)} options={splideOptions} ref={gallerySlider}>
                    {newDoctors.map((doctor, i) => (
                        <SplideSlide key={i + 'gal-slider'}>
                            <div className='img-box' data-slide-num={i}>
                                <img src={doctor.icon} alt=''/>
                            </div>
                        </SplideSlide>
                    ))}
                </Splide>
            </div>
        </div>
    )
}

export default DoctorsSection
